// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"780":"f6201c07c4e81c7a46e1","972":"328ba92b2e598e13ac4f"}[chunkId] + ".css";
};